import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { DelegationsManagementPage } from '../shared/DelegationsManagementPage';

const AdminDelegationsPage: React.FC = () => {
  return (
    <AdminLayout>
      <DelegationsManagementPage mode="admin" />
    </AdminLayout>
  );
};

export default AdminDelegationsPage;
